import {
  parsePhoneNumberFromString,
  isSupportedCountry,
  type CountryCode,
} from "libphonenumber-js/max";

export const DEFAULT_PHONE_COUNTRY: CountryCode = "IR";

export function normalizePhoneDigits(value: string) {
  return value
    .replace(/[۰-۹٠-٩]/g, (digit) =>
      String(digit.charCodeAt(0) - (digit >= "۰" ? 0x06f0 : 0x0660)),
    )
    .trim();
}

export function parsePhone(
  value: string,
  country: string | null = DEFAULT_PHONE_COUNTRY,
) {
  const code = (country ?? DEFAULT_PHONE_COUNTRY).toUpperCase() as CountryCode;
  if (!isSupportedCountry(code)) return undefined;
  const input = normalizePhoneDigits(value).replace(/^00/, "+");
  const parsed = parsePhoneNumberFromString(input, {
    defaultCountry: code,
    extract: false,
  });
  if (!parsed?.isValid() || parsed.ext) return undefined;
  // A selected country must agree with an explicitly international number.
  if (parsed.country && parsed.country !== code) return undefined;
  return parsed;
}

export function normalizePhoneNumber(
  value: string,
  country?: string | null,
): string | null {
  return parsePhone(value, country)?.number ?? null;
}

export function isValidPhoneNumber(value: string, country?: string | null) {
  return Boolean(parsePhone(value, country));
}

// Profile records store E.164 without a separate phone-country column.
export function normalizeStoredPhone(value: string): string | null {
  const input = normalizePhoneDigits(value).replace(/^00/, "+");
  const parsed = parsePhoneNumberFromString(input, {
    defaultCountry: DEFAULT_PHONE_COUNTRY,
    extract: false,
  });
  return parsed?.isValid() && !parsed.ext ? parsed.number : null;
}
